<template>
  <div class="sticky compatible-sticky" id="bottom-bar">
    <bottom-bar-button @click.native="toShareBtnUrl" v-if="isDisplayFuncBtn" :type="styleType.left">
      <img v-if="displayPlayer" src="/images/free_player.png" alt="" class="player">
      {{funcText}}
    </bottom-bar-button>
    <bottom-bar-button @click.native="toBuy" v-if="isDisplayBuyBtn" :type="styleType.right">
      <div v-html="buyText"></div>
    </bottom-bar-button>
    <div class="compatible"></div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { isEmpty } from "lodash";
import BottomBarButton from "./bottomBarButton";
import { resourceType } from "@/utils/const";
export default {
  components: { BottomBarButton },
  props: {
    dataDetail: {
      type: Object,
      // required: true,
      default: () => ({
        // days: 365,
        // goodsId: 2,
        // introduction: "0-3岁会员礼包",
        // marketPrice: 388,
        // name: "0-3岁会员礼包",
        // picture: "http://images.cms.zhibankeji.com/image/dev/1555918199303.jpg",
        // price: 0,
        // productId: 45,
        // status: 0
      })
    },
    mode: {
      type: Number,
      required: true
    },
    styleType: {
      type: Object,
      default: () => ({ left: "share", right: "buy" })
    }
  },
  methods: {
    toBuy() {
      console.info('bottom','toBuy');
      this.$emit("bottomBarHandler", "toBuy");
    },
    toShareBtnUrl() {
      this.$emit("bottomBarHandler", "toShareBtnUrl");
    }
  },
  computed: {
    buyText() {
      switch (this.mode) {
        case resourceType.album:
          let text = "";
          if (this.dataDetail.album.charge == 2) {
            this.dataDetail.goodsDetail;
            text = this.isPlusMember
              ? `会员：${this.dataDetail.goodsDetail.price}<span>智豆 <del>${
                  this.dataDetail.goodsDetail.marketPrice
                }</del></span>`
              : "购买：" + this.dataDetail.goodsDetail.marketPrice;
          }
          if (this.dataDetail.album.charge == 1) {
            this.dataDetail.goodsDetail;
            text = "购买礼包";
          }
          return text;
          break;
        case resourceType.package:
          return this.userInfo &&
            this.dataDetail &&
            this.dataDetail.status !== 0 //this.dataDetail.status 0为未购买
            ? `立即续费 ¥${this.dataDetail.price || 0}<span style="font-size:14px;">/年</span>`
            : `立即开通 ¥${this.dataDetail.price || 0}<span style="font-size:14px;">/年</span>`;
          break;
        case resourceType.video:
          return this.isPlusMember? "是" : "马上购买";
          break;
        default:
          return "";
      }
    },
    funcText() {
      switch (this.mode) {  
        case resourceType.album:
          return this.isPlusMember
            ? "分享" + (this.dataDetail.album.charge == 0 ? "" : "赚收益")
            : "试听";
          break;
        case resourceType.package:
          //游客代码
          if(this.isVisitor){
            return "马上注册体验"
          }
          return !isEmpty(this.userInfo) ? "邀好友 赚收益" : "马上注册体验";
          break;
        case resourceType.video:
          return this.isPlusMember ?  "否" : ((this.contextIdInfo && this.contextIdInfo.appLevel > 0) ?"取消" : "知道了");
          break;
        default:
          return "";
      }
    },
    isDisplayFuncBtn() {
      switch (this.mode) {
        case resourceType.album:
          return !this.dataDetail.isFree || this.isPlusMember; //未购 或 是plus会员
          break;
        case resourceType.package:
          //游客代码
          return isEmpty(this.userInfo) || this.isPlusMember ||this.isVisitor; //未登录或者是plus会员
          break;
        case resourceType.video:
          return true;
          break;
        default:
          return false;
      }
    },
    isDisplayBuyBtn() {
      switch (this.mode) {
        case resourceType.album:
          return !isEmpty(this.dataDetail) ? !this.dataDetail.isFree : true;
          break;
        case resourceType.package:
          return !isEmpty(this.dataDetail)
          break;
        case resourceType.video:
          return this.dataDetail.isFree //是否有邀请码
          break;
        default:
          return true;
      }
    },
    displayPlayer() {
      if (this.mode == resourceType.album) {
        if (!isEmpty(this.dataDetail)) {
          return (
            (!this.isPlusMember || isEmpty(this.userInfo)) &&
            this.dataDetail.isFree
          );
        }
      }
    },
    ...mapGetters({
      isPlusMember: "auth/isPlusMember",
      userInfo: "auth/userInfo",
      isVisitor:"auth/isVisitor",
      contextIdInfo: "auth/contextIdInfo"
    })
  }
};
</script>
<style scoped>
.sticky {
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  border-radius: 16px 16px 0px 0px;
  overflow: hidden;
}
.sticky > a {
  display: block;
  flex: 1;
  text-align: center;
  font-size: 16px;
  line-height: 52px;
}
.sticky >>> .buy span {
  font-size: 12px;
}

.sticky >>> .normal span {
  font-size: 12px;
}
.sticky .player {
  width: 22px;
  height: 22px;
  margin-right: 7px;
  vertical-align: middle;
}
</style>



